module.exports = "<div class=\"card\" [ngClass]=\"{'is-collapsed': collapsed, 'active': !collapsed}\">\r\n  <ng-content></ng-content>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/accordion/components/sb-item.html
// module id = ../../../../../src/libs/mdbootstrap/typescripts/pro/accordion/components/sb-item.html
// module chunks = main